import React, { useRef, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ReactToPrint from 'react-to-print';
import { selectCidade } from '../../app/slices/cidadesSlice';
import { fecharModalImpressaoSic, selectModal } from '../../app/slices/modalSlice';
import LogoImg from '../../assets/icons/logo.png';
import {
  ContainerJanela, Divisor, Linha,
} from '../../styles/base';
import { replaceTags } from '../../util/stringFactory';
import Botao from '../Botao/Botao';
import PdfPng from '../../assets/icons/pdf.png';
import {
  ContainerImpressao, HeaderImpressao, InternaImpressao, JanelaImpressao,
  SecaoImpressao,
} from './ModalImpressaoEstilo';

const ModalImpressaoSic = () => {
  const [count, setCount] = useState(0);
  const dadosCidade = useSelector(selectCidade);
  const dadosModal = useSelector(selectModal);
  const dispatch = useDispatch();
  const ref = useRef();
  const Brasao = dadosCidade.data.brasaoCidade;

  useEffect(() => {
    if (dadosModal.dados.arquivos) {
      // eslint-disable-next-line array-callback-return
      dadosModal.dados.arquivos.map(({ Valor }) => {
        if (Valor.endsWith('mp4') || Valor.endsWith('mov') || (Valor.endsWith('mp3') || Valor.endsWith('aac') || Valor.endsWith('.ogg'))) {
          return;
        }
        setCount((prevCount) => prevCount + 1);
      });
    }
  }, []);

  return (
    <ContainerJanela>
      <JanelaImpressao>
        <Linha style={{ justifyContent: 'space-between' }}>
          <ReactToPrint
            trigger={() => <Botao impressao label="Imprimir" />}
            content={() => ref.current}
          />
          <Botao
            fechar
            onClick={() => dispatch(fecharModalImpressaoSic())}
          />
        </Linha>

        <Divisor />

        <ContainerImpressao ref={ref}>
          <HeaderImpressao>
            <Linha>
              <img src={`https://eouve.com.br/Sistema/Arquitetura/Logos/${Brasao}`} width={70} alt="Brasão da cidade" />
              <p>
                {/* Comentado abaixo pois nem todas são prefeituras mais. É necessário rever a estratégia de vir dinâmico. */}
                {/* <small>
                  Prefeitura municípal de
                </small>
                <br /> */}
                <strong style={{ fontSize: '1.2em' }}>{dadosCidade.data.nomeCidade}</strong>
              </p>
            </Linha>
            <div>
              <img src={LogoImg} width={50} alt="Logo eOuve - Sistema de Ouvidoria" />
            </div>
          </HeaderImpressao>

          <Divisor />

          <InternaImpressao>
            <Linha style={{ justifyContent: 'space-between' }}>
              <div>
                <b>Protocolo:</b>
                {' '}
                {dadosModal.dados.id}
              </div>
            </Linha>

            <Divisor size="ultraPequeno" />

            <Linha>
              <div>
                <b>Secretaria:</b>
                {' '}
                {dadosModal.dados.secretaria}
              </div>
            </Linha>

            <Divisor size="ultraPequeno" />

            {dadosModal.dados.assunto && (
              <>
                <Linha>
                  <div>
                    <b>Assunto:</b>
                    {' '}
                    {dadosModal.dados.assunto}
                  </div>
                </Linha>

                <Divisor size="ultraPequeno" />
              </>
            )}

            <Linha>
              <div>
                <b>Data de abertura:</b>
                {' '}
                {dadosModal.dados.dataHora}
              </div>
            </Linha>

            <Divisor size="ultraPequeno" />

            <Linha>
              <div>
                <b>Pergunta:</b>
                {' '}
                {dadosModal.dados.pergunta}
              </div>
            </Linha>

            <Divisor size="ultraPequeno" />
          </InternaImpressao>

          <Divisor size="ultraPequeno" />

          {dadosModal.dados.resposta && !dadosModal.dados.retificacao && (
            <InternaImpressao>
              <Linha style={{ justifyContent: 'space-between' }}>
                <div>
                  <b>Resposta:</b>
                  {' '}
                </div>
                <div>
                  <small>{dadosModal.dados.dataHoraResposta}</small>
                </div>
              </Linha>
              <SecaoImpressao>
                {replaceTags(dadosModal.dados.resposta)}
              </SecaoImpressao>

              <Divisor size="ultraPequeno" />
            </InternaImpressao>
          )}

          {dadosModal.dados.retificacao && (
          <InternaImpressao>
            <Linha style={{ justifyContent: 'space-between' }}>
              <div>
                <b>Retificação:</b>
                {' '}
              </div>
              <div>
                <small>{dadosModal.dados.dataHoraRetificacao}</small>
              </div>
            </Linha>
            <SecaoImpressao>
              {replaceTags(dadosModal.dados.retificacao)}
            </SecaoImpressao>

            <Divisor size="ultraPequeno" />
          </InternaImpressao>
          )}

          <Divisor size="ultraPequeno" />

          {dadosModal.dados.recurso && (
            <InternaImpressao>
              <Linha style={{ justifyContent: 'space-between' }}>
                <div>
                  <b>Recurso:</b>
                  {' '}
                </div>
                <div>
                  <small>{dadosModal.dados.dataHoraAberturaRecurso}</small>
                </div>
              </Linha>
              <SecaoImpressao>
                {replaceTags(dadosModal.dados.recurso)}
              </SecaoImpressao>

              <Divisor size="ultraPequeno" />
            </InternaImpressao>
          )}

          <Divisor size="ultraPequeno" />

          {dadosModal.dados.respostaRecurso && (
          <InternaImpressao>
            <Linha style={{ justifyContent: 'space-between' }}>
              <div>
                <b>Resposta recurso:</b>
                {' '}
              </div>
              <div>
                <small>{dadosModal.dados.dataHoraRespostaRecurso}</small>
              </div>
            </Linha>
            <SecaoImpressao>
              {replaceTags(dadosModal.dados.respostaRecurso)}
            </SecaoImpressao>
          </InternaImpressao>
          )}

          <Divisor size="ultraPequeno" />

          {dadosModal.dados.recursoRetificacao && (
          <InternaImpressao>
            <Linha style={{ justifyContent: 'space-between' }}>
              <div>
                <b>Recurso da Retificação:</b>
                {' '}
              </div>
              <div>
                <small>{dadosModal.dados.dataHoraAberturaRecursoRetificacao}</small>
              </div>
            </Linha>
            <SecaoImpressao>
              {replaceTags(dadosModal.dados.recursoRetificacao)}
            </SecaoImpressao>

            <Divisor size="ultraPequeno" />
          </InternaImpressao>
          )}

          <Divisor size="ultraPequeno" />

          {dadosModal.dados.respostaRecursoRetificacao && (
          <InternaImpressao>
            <Linha style={{ justifyContent: 'space-between' }}>
              <div>
                <b>Resposta do Recurso da Retificação:</b>
                {' '}
              </div>
              <div>
                <small>{dadosModal.dados.dataHoraRespostaRecursoRetificacao}</small>
              </div>
            </Linha>
            <SecaoImpressao>
              {replaceTags(dadosModal.dados.respostaRecursoRetificacao)}
            </SecaoImpressao>

            <Divisor size="ultraPequeno" />
          </InternaImpressao>
          )}

          <Divisor size="ultraPequeno" />

          {(dadosModal.dados.arquivos && dadosModal.dados.arquivos.length) ? (
            <>
              <Divisor size="ultraPequeno" />

              {count ? (
                <InternaImpressao>
                  <div>
                    <b>Anexos:</b>
                  </div>

                  {dadosModal.dados.arquivos.map(({ Valor }) => {
                    if (Valor.endsWith('zip') || Valor.endsWith('rar') || Valor.endsWith('pdf') || Valor.endsWith('zip') || Valor.endsWith('mp3') || Valor.endsWith('aac') || Valor.endsWith('ogg') || Valor.endsWith('mp4') || Valor.endsWith('mov')) {
                      return (
                        <>
                        </>
                      );
                    }

                    return (
                      <>
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                          <img src={Valor} alt="Anexo" style={{ maxHeight: 300 }} />
                        </div>
                        <Divisor size="ultraPequeno" />
                      </>
                    );
                  })}
                </InternaImpressao>
              ) : ('')}
            </>
          ) : (null)}
        </ContainerImpressao>
      </JanelaImpressao>
    </ContainerJanela>
  );
};

export default ModalImpressaoSic;
